import { EYapeFormError } from 'core/model/enums/yape.enum';
import { IUploadFileParams } from 'core/model/interfaces/downloads-uploads';
import { IServiceErrorContent } from 'core/model/interfaces/service.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleSpecificErrors } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../constants';
import type { IYapeState } from '../types';

export const uploadClientList = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/uploadClientList`,
  async (params: IUploadFileParams, { rejectWithValue }) => {
    try {
      await apiService.uploads.uploadFile(params);
      notificationService.global.success('Se cargó la lista de clientes correctamente.');
    } catch (e) {
      const handledError = handleSpecificErrors(
        e,
        'Error inesperado mientras se cargaba una lista de usuarios',
        Object.values(EYapeFormError),
      );
      if (handledError) return rejectWithValue(handledError);

      throw e;
    }
  },
);

export const uploadClientListReducer: TSliceExtraReducer<IYapeState> = builder =>
  builder
    .addCase(uploadClientList.pending, state => {
      state.promo.form.loading = true;
      state.promo.form.success = false;
      state.promo.form.errors = {};
    })
    .addCase(uploadClientList.rejected, (state, action) => {
      state.promo.form.loading = false;
      state.promo.form.success = false;
      const { code, details } = (action.payload ?? {}) as IServiceErrorContent;
      if (code === EYapeFormError.INVALID_CODES) state.promo.form.errors.invalidCodes = details[0] as string;
    })
    .addCase(uploadClientList.fulfilled, state => {
      state.promo.form.loading = false;
      state.promo.form.success = true;
      state.promo.form.errors = {};
    });
